import ToastError from "../../../components/molecules/ToastError"
import { extractPackServices } from "../../../core/service/BusinessLogicService"
import { PackServiceContext } from "../../../digital-journey/ServicePage/context/PackServiceContext"
import { TunnelDataContext } from "../../../digital-journey/context/TunnelDataContext"
import { apigateway } from "../../../intances/apigateway"
import useLocalStorageSimulationForm from "./useLocalStorageSimulationForm"
import moment from "moment"
import React, { useCallback, useContext, useState } from "react"
import toast from "react-hot-toast"

function useSimulationSubmit() {
  const tunnelDataContext = useContext(TunnelDataContext)

  const [quantity, setQuantity] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [product, setProduct] = useState(null)

  const { getLocalStorageSimulationForm, setLocalStorageSimulationForm, remove } = useLocalStorageSimulationForm()

  const { packContext, changePackContext, selectedPack, setSelectedPack, verifyiedPromotionCode } =
    useContext(PackServiceContext)

  const simulationSubmit = useCallback(
    (values, defaultDuration) => {
      setQuantity(values.quantity)
      setIsLoading(true)
      setProduct(values)
      setLocalStorageSimulationForm(values)

      const productSkuList = []
      const monoproduct = values.products.length === 1
      if (!monoproduct) {
        values.products.forEach(function (product) {
          const content = {
            productSku: product.sku?.value ? product?.sku?.value?.skuDistributor : null,
            productPriceWithTaxes: product?.sku?.value ? product?.sku?.value?.priceIncTaxes : product.price,
            indicativePublicPriceWithTaxes: product?.sku?.value
              ? product?.sku?.value?.indicativePublicPriceIncTax
              : product?.price,
            productCategoryId: product?.category?.value
          }
          productSkuList.push(content)
        })
      }

      const catIds = values.products.map((product) => product.category.value)
      const payloadOffersActives = {
        beneficiary: {
          id: values.shop.value.split("-")[0]
        },
        categoryIds: catIds
      }
      apigateway(tunnelDataContext?.tunnelData)
        .post("api/v2/offers/actives", payloadOffersActives)
        .then((res) => {
          let payloadRentCalculation
          if (monoproduct) {
            payloadRentCalculation = {
              offerId: res?.data?.[0]?.offerId,
              simulationDate: moment().format("YYYY-MM-DD"),
              productSku: !!values.products[0]?.sku ? values.products[0].sku.value.skuDistributor : null,
              supplierReference: values.shop.value.split("-")[1],
              productCategoryId: values.products[0].category?.value,
              productPriceWithTaxes: values.products[0].price,
              promotionCodes: values?.promoCode ? [values?.promoCode] : null
            }
          } else {
            payloadRentCalculation = {
              offerIds: [res?.data?.[0]?.offerId],
              simulationDate: moment().format("YYYY-MM-DD"),
              productSku: null,
              productSkuList: !productSkuList.length ? null : productSkuList,
              supplierReference: values.shop.value.split("-")[1],
              productCategoryId: values?.category?.value,
              promotionCodes: values?.promoCode ? [values?.promoCode] : null
            }
          }
          apigateway(tunnelDataContext?.tunnelData)
            .post("middle-business-service/api/v2/leases/lease-rent-calculation", payloadRentCalculation)
            .then((response) => {
              const packs = extractPackServices(response.data, null)
              if (values.products) {
                apigateway(tunnelDataContext?.tunnelData)
                  .post("api/v2/products/get-by-criteria", {
                    productReferenceList: values.products.map((p) => p.sku.value.skuDistributor),
                    supplierId: values.shop.value.split("-")[0]
                  })
                  .then((productResponse) => {
                    const packsOrdered = packs?.sort((a, b) => a?.rentDTO?.duration - b?.rentDTO?.duration)

                    let packToSave = packsOrdered?.[0]
                    if (defaultDuration) {
                      packToSave = packsOrdered.find((x) => x?.rentDTO?.duration === defaultDuration)
                    }

                    setSelectedPack(packToSave)
                    changePackContext({
                      ...packContext,
                      product: productResponse.data.map((pack) => {
                        const formMatchingProduct = values?.products?.find(
                          (formProduct) => formProduct.sku.value.skuDistributor === pack?.skuDistributor
                        )
                        const isCustomPrice = Number(formMatchingProduct?.price) !== pack?.priceIncTaxes
                        return {
                          ...pack,
                          priceIncTaxes: isCustomPrice ? Number(formMatchingProduct?.price) : pack?.priceIncTaxes,
                          indicativePublicPriceIncTax: isCustomPrice
                            ? Number(formMatchingProduct?.price)
                            : pack?.indicativePublicPriceIncTax
                        }
                      }),
                      packs,
                      shop: values?.shop,
                      delivery: values?.delivery
                    })
                    setIsLoading(false)
                  })
                return
              }
              changePackContext({ ...packContext, packs })
              setIsLoading(false)
            })
            .catch((error) => {
              const {
                response: { data }
              } = error
              setIsLoading(false)
              toast.error((t) => <ToastError message={data.message} handlePictoClick={() => toast.dismiss(t.id)} />, {
                id: data.message,
                duration: Infinity
              })
            })
        })
        .catch((error) => {
          console.error("ServicePack error : ", error)
          setIsLoading(false)
        })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [changePackContext, packContext, setSelectedPack, tunnelDataContext?.tunnelData]
  )

  function simulationSubmitNoUseCallBack(values, defaultDuration) {
    setQuantity(values.quantity)
    setIsLoading(true)
    setProduct(values)
    setLocalStorageSimulationForm(values)

    const isPromotionCodeValid = verifyiedPromotionCode?.valid

    const productSkuList = []
    const monoproduct = values.products.length === 1
    if (!monoproduct) {
      values.products.forEach(function (product) {
        const content = {
          productSku: product.sku?.value ? product?.sku?.value?.skuDistributor : null,
          productPriceWithTaxes: product?.sku?.value ? product?.sku?.value?.priceIncTaxes : product.price,
          indicativePublicPriceWithTaxes: product?.sku?.value
            ? product?.sku?.value?.indicativePublicPriceIncTax
            : product?.price,
          productCategoryId: product?.category?.value
        }
        productSkuList.push(content)
      })
    }

    const catIds = values.products.map((product) => product.category.value)
    const payloadOffersActives = {
      beneficiary: {
        id: values.shop.value.split("-")[0]
      },
      categoryIds: catIds
    }
    apigateway(tunnelDataContext?.tunnelData)
      .post("api/v2/offers/actives", payloadOffersActives)
      .then((res) => {
        let payloadRentCalculation
        if (monoproduct) {
          payloadRentCalculation = {
            offerIds: [res?.data?.[0]?.offerId],
            simulationDate: moment().format("YYYY-MM-DD"),
            productSku: !!values.products[0]?.sku ? values.products[0].sku.value.skuDistributor : null,
            supplierReference: values.shop.value.split("-")[1],
            productCategoryId: values.products[0].category?.value,
            productPriceWithTaxes: values.products[0].price,
            promotionCodes: isPromotionCodeValid && values?.promoCode ? [values?.promoCode] : null
          }
        } else {
          payloadRentCalculation = {
            offerIds: [res?.data?.[0]?.offerId],
            simulationDate: moment().format("YYYY-MM-DD"),
            productSku: null,
            productSkuList: !productSkuList.length ? null : productSkuList,
            supplierReference: values.shop.value.split("-")[1],
            productCategoryId: values?.category?.value,
            promotionCodes: isPromotionCodeValid && values?.promoCode ? [values?.promoCode] : null
          }
        }
        apigateway(tunnelDataContext?.tunnelData)
          .post("api/v2/leases/lease-rent-calculation", payloadRentCalculation)
          .then((response) => {
            const packs = extractPackServices(response.data, null)
            if (values.products) {
              apigateway(tunnelDataContext?.tunnelData)
                .post("api/v2/products/get-by-criteria", {
                  productReferenceList: values.products.map((p) => p.sku.value.skuDistributor),
                  supplierId: values.shop.value.split("-")[0]
                })
                .then((productResponse) => {
                  const packsOrdered = packs?.sort((a, b) => a?.rentDTO?.duration - b?.rentDTO?.duration)
                  let packToSave = packsOrdered?.[0]
                  if (defaultDuration) {
                    packToSave = packsOrdered.find((x) => x?.rentDTO?.duration === defaultDuration)
                  }
                  setSelectedPack(packToSave)

                  changePackContext({
                    ...packContext,
                    product: productResponse.data.map((pack) => {
                      const formMatchingProduct = values?.products?.find(
                        (formProduct) => formProduct.sku.value.skuDistributor === pack?.skuDistributor
                      )
                      const isCustomPrice = Number(formMatchingProduct?.price) !== pack?.priceIncTaxes
                      return {
                        ...pack,
                        priceIncTaxes: isCustomPrice ? Number(formMatchingProduct?.price) : pack?.priceIncTaxes,
                        indicativePublicPriceIncTax: isCustomPrice
                          ? Number(formMatchingProduct?.price)
                          : pack?.indicativePublicPriceIncTax
                      }
                    }),
                    packs,
                    shop: values?.shop,
                    delivery: values?.delivery
                  })
                  setIsLoading(false)
                })
              return
            }
            changePackContext({ ...packContext, packs })
            setIsLoading(false)
          })
          .catch((error) => {
            const {
              response: { data }
            } = error
            setIsLoading(false)
            toast.error((t) => <ToastError message={data.message} handlePictoClick={() => toast.dismiss(t.id)} />, {
              id: data.message,
              duration: Infinity
            })
          })
      })
      .catch((error) => {
        console.error("ServicePack error : ", error)
        setIsLoading(false)
      })
  }

  return {
    simulationSubmit,
    simulationSubmitNoUseCallBack,
    isLoading,
    product,
    setProduct,
    quantity,
    getLocalStorageSimulationForm,
    setLocalStorageSimulationForm,
    remove,
    packContext,
    changePackContext,
    selectedPack,
    setSelectedPack
  }
}

export default useSimulationSubmit
